<template>
    <v-simple-table>
        <tbody>
            <template v-if="items">
                <tr v-for="item in items" v-bind:key="item.id">
                    <td>{{ item.itemProductQuantity }} x </td>
                    <td style="width:80px;" v-if="$vuetify.breakpoint.smAndUp">
                        <v-img
                            height="80"
                            width="80"
                            :src="item.itemProduct.thumbnail | toCDNPath"
                            contain
                        ></v-img>
                    </td>
                    <td>{{ item.itemProduct.name }}</td>
                </tr>
            </template>
        </tbody>
    </v-simple-table>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
            };
        },

        props: {
            items: Array
        }
    };
</script>

<style lang="scss" scoped>

</style>
